import React from 'react';
import Header from '../components/Header/Header';
import TendersHero from '../components/TendersHero/TendersHero';
import Footer from '../components/Footer/Footer';
import Markets from '../components/Markets/Markets';
import Advantage from '../components/Advantage/Advantage';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import TendersIntro from '../components/TendersIntro/TendersIntro';
import TenderAccess from '../components/TenderAccess/TenderAccess';
import SmartNavigation from '../components/SmartNavigation/SmartNavigation';


const TendersPage = () => {
  return (
    <>
      <Header />
      <main>
        <TendersHero />
        <Markets />
        <TendersIntro /> 
        <TenderAccess />
        <SmartNavigation />
        {/* You can add a list of tenders or other components here later */}
        <Advantage /> 
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default TendersPage;